import { createSelector } from "reselect";

import { RootState } from "../../store/types";
import { ProductSearchState } from "./reducer";

export const price = (state: RootState): ProductSearchState =>
  state.productSearch;
export const searchValue = createSelector(price, state => state.searchValue);
export const suggestions = createSelector(price, state => state.suggestions);

export const isSuggestionsLoading = createSelector(
  price,
  state => state.isSuggestionsLoading,
);

export const isSuggestionsShown = createSelector(
  price,
  state => state.isSuggestionsShown,
);



// WEBPACK FOOTER //
// ./src/routes/ProductSearch/selectors.ts